<script lang="ts">
  import { getSlotStyle, styleToString } from "@shared/common/node/style";
  import type { ISlotNode, PartialNode } from "@shared/common/node/type";
  import { onMount } from "svelte";
  import {
    getStore,
    setDocumentNodeContext,
    setIsChildDocument,
  } from "../../context";
  import Node from "../node/node.svelte";

  const {
    childrenNodeData,
    impressionEventStatusMap,
    rootShown,
    onImpressionEvent,
  } = getStore();

  export let node: PartialNode<ISlotNode>;
  export let depth: number;
  export let wrapperType: "iframe" | "embedded";

  // TODO: slot node의 children이 여러개일 경우에 대한 처리
  const childNode = $childrenNodeData?.[0];

  if (childNode) {
    setDocumentNodeContext(childNode);
    setIsChildDocument(true);
  }

  $: if ($rootShown && childNode && childNode.id) {
    const isImpressionSent = $impressionEventStatusMap?.get(childNode.id);
    if (!isImpressionSent) {
      $onImpressionEvent(childNode)
        .then(() => {
          if (childNode.id) {
            $impressionEventStatusMap?.set(childNode.id, true);
          }
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.error(e);
        });
    }
  }

  onMount(() => {
    if (node.id) {
      $impressionEventStatusMap?.set(node.id, false);
    }
  });
</script>

<!-- TODO: slot node의 children이 여러개일 경우에 대한 처리 -->
{#if childNode}
  <div style={styleToString(getSlotStyle(node))}>
    <Node node={childNode} {depth} {wrapperType} />
  </div>
{/if}
